import { useCallback, useMemo } from "react";
import {
	runOnJS,
	useAnimatedStyle,
	useSharedValue,
	withDecay,
	withSpring,
} from "react-native-reanimated";
import { MainGesturePanListener } from "src/components/ImageGallery/types";
import useDevice from "src/hooks/useDevice";
import useStyle from "src/hooks/useStyle";
import { useModalContext } from "src/modals/contexts/ModalContext";
import { color } from "src/styles";

const usePhotoDetailDismiss = () => {
	const { device } = useDevice();
	const context = useModalContext();
	const initialY = useSharedValue(0);
	const translateY = useSharedValue(0);
	const { theme } = useStyle();

	const closeSelf = useCallback(() => {
		if (context) {
			context.closeSelf();
		}
	}, [context]);
	const mainGesturePanListener = useMemo<MainGesturePanListener | undefined>(() => {
		if (device === "desktop") return undefined;

		return {
			onBegin: (event) => {
				"worklet";
				initialY.value = event.translationY;
			},
			onChange: (event) => {
				"worklet";
				const newTranslateY = event.translationY - initialY.value;
				if (
					(newTranslateY > 10 && Math.abs(event.translationX) < 10) ||
					translateY.value > 0
				) {
					translateY.value = newTranslateY;
				}
			},
			onEnd: (event) => {
				"worklet";
				const shouldDismiss =
					translateY.value +
						(0.002 * event.velocityY) / Math.max(Math.abs(event.absoluteX), 1) >
					100;
				if (shouldDismiss) {
					translateY.value = withDecay({
						velocity: Math.max(event.velocityY, 5),
						clamp: [0, 1000],
					});
					runOnJS(closeSelf)();
				} else {
					translateY.value = withSpring(0, {
						velocity: event.velocityY,
						overshootClamping: true,
					});
				}
			},
		};
	}, [closeSelf, device, initialY, translateY]);
	const animatedStyle = useAnimatedStyle(() => {
		return {
			flex: 1,
			transform: [
				{
					translateY: translateY.value,
				},
			],
			opacity: Math.max(1 - translateY.value / 500, 0.5),
			backgroundColor: color.Background[theme],
		};
	}, [theme, translateY]);

	return {
		mainGesturePanListener,
		animatedStyle,
	};
};
export default usePhotoDetailDismiss;
